import { put } from "redux-saga/effects";
import { message } from "antd";

import { ApiCaller } from "../../config";
import { AdminAction } from "../actions";
import { DefaultNotification } from "../../components";

export default class AdminMiddleware {
  static *getDashInfo({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/admin/dashboard-info`);
      if (res.status === 200) {
        yield put(AdminAction.getDashInfoSuccess(res.data.data));
      } else {
        yield put(AdminAction.getDashInfoFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(AdminAction.getDashInfoFailure());
    }
  }
  static *getRegPerMonth({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/admin/get-data-per-month`);
      if (res.status === 200) {
        yield put(AdminAction.getRegPerMonthSuccess(res.data.data));
      } else {
        yield put(AdminAction.getRegPerMonthFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(AdminAction.getRegPerMonthFailure());
    }
  }
}
